import { FinanceAndAccountRights, UserRight } from "@/enums/enums";
import { AbilityBuilder } from "@casl/ability";

function GetUserRight(user: any) {
  switch (user.role1) {
    case 1:
      if (user.role4 == 1) {
        return UserRight.BasicAndAdmin;
      } else {
        if (user.role2 == 1) {
          return UserRight.Standard;
        } else {
          return UserRight.Standard;
        }
      }
      break;
    case 2:
      return UserRight.ViewOnly;
      break;
    case 3:
      return UserRight.RevenueExpenseDraftOnly;
      break;
    case 4:
      return UserRight.RevenueExpenseApproveOnly;
      break;
    case 5:
      return UserRight.RevenueAll;
      break;
    case 6:
      return UserRight.ExpenseAll;
      break;
    case 7:
      return UserRight.QuotationOnly;
      break;
    case 8:
      return UserRight.CreateRevenueOnly;
      break;
    case 9:
      return UserRight.CreateExpenseOnly;
      break;
    case 10:
      return UserRight.PurchaseOrderOnly;
      break;
    case 11:
      return UserRight.RevenueDraftOnly;
      break;
    case 12:
      return UserRight.ExpenseDraftOnly;
      break;
    case 13:
      return UserRight.RevenueApproveOnly;
      break;
    case 14:
      return UserRight.ExpenseApproveOnly;
      break;
    case 15:
      return UserRight.QuotationDraftOnly;
      break;
    case 16:
      return UserRight.QuotationApproveOnly;
      break;
    case 17:
      return UserRight.PurchaseOrderDraftOnly;
      break;
    case 18:
      return UserRight.PurchaseOrderApproveOnly;
      break;
  }
}
function RevenueBaseView(can: any) {
  can("access", "Import_Document");
  can("access", "Income_Menu");
}
function QuotationView(can: any) {
  can("access", "Quotation_Income_Menu");
  can("access", "Quotation_Detail");
}
function InvoiceView(can: any) {
  can("access", "Invoice_Income_Menu");
  can("access", "Invoice_Detail");
}
function ReceiptView(can: any) {
  can("access", "Receipt_Income_Menu");
  can("access", "Receipt_Detail");
}
function TaxInvoiceView(can: any) {
  can("access", "TaxInvoice_Income_Menu");
  can("access", "TaxInvoice_Detail");
}
function CreditNoteView(can: any) {
  can("access", "CreditNote_Income_Menu");
  can("access", "CreditNote_Detail");
}
function BillingNoteView(can: any) {
  can("access", "BillingNote_Income_Menu");
  can("access", "BillingNote_Detail");
}
function DebitNoteView(can: any) {
  can("access", "DebitNote_Income_Menu");
  can("access", "DebitNote_Detail");
}
function QuotationCreate(can: any) {
  can("create", "Document_Quotation_Income");
}
function InvoiceCreate(can: any) {
  can("create", "Document_Invoice_Income");
}
function ReceiptCreate(can: any) {
  can("create", "Document_Receipt_Income");
}
function TaxInvoiceCreate(can: any) {
  can("create", "Document_TaxInvoice_Income");
}
function CreditNoteCreate(can: any) {
  can("create", "Document_CreditNote_Income");
}
function DebitNoteCreate(can: any) {
  can("create", "Document_DebitNote_Income");
}
function BillingNoteCreate(can: any) {
  can("create", "Document_BillingNote_Income");
}
function QuotationApprove(can: any) {
  can("update", "Tag_QuotationIncome");
  can("update", "Approve_Document_QuotationIncome");
  can("create", "SendEmail_QuotationIncome");
  can("update", "Void_Document_QuotationIncome");
}
function InvoiceApprove(can: any) {
  can("update", "Tag_InvoiceIncome");
  can("update", "Approve_Document_InvoiceIncome");
  can("create", "SendEmail_InvoiceIncome");
  can("update", "Void_Document_InvoiceIncome");
}
function ReceiptApprove(can: any) {
  can("update", "Tag_ReceiptIncome");
  can("update", "Approve_Document_ReceiptIncome");
  can("create", "SendEmail_ReceiptIncome");
  can("update", "Void_Document_ReceiptIncome");
}
function TaxInvoiceApprove(can: any) {
  can("update", "Tag_TaxInvoiceIncome");
  can("update", "Approve_Document_TaxInvoiceIncome");
  can("create", "SendEmail_TaxInvoiceIncome");
  can("update", "Void_Document_TaxInvoiceIncome");
}
function CreditNoteApprove(can: any) {
  can("update", "Tag_CreditNoteIncome");
  can("update", "Approve_Document_CreditNoteIncome");
  can("create", "SendEmail_CreditNoteIncome");
  can("update", "Void_Document_CreditNoteIncome");
}
function DebitNoteApprove(can: any) {
  can("update", "Tag_DebitNoteIncome");
  can("update", "Approve_Document_DebitNoteIncome");
  can("create", "SendEmail_DebitNoteIncome");
  can("update", "Void_Document_DebitNoteIncome");
}
function BillingNoteApprove(can: any) {
  can("update", "Tag_BillingNoteIncome");
  can("update", "Approve_Document_BillingNoteIncome");
  can("create", "SendEmail_BillingNoteIncome");
  can("update", "Void_Document_BillingNoteIncome");
}
function QuotationDraft(can: any) {
  can("create", "Copy_Document_QuotationIncome");
  can("update", "Void_Document_Draft_QuotationIncome");
  can("update", "Draft_Document_QuotationIncome");
  can("update", "Send_Approve_QuotationIncome");
  can("update", "Tag_QuotationIncome");
  can("update", "Accepted_Document_QuotationIncome");
  can("create", "SendEmail_QuotationIncome");
}
function InvoiceDraft(can: any) {
  can("create", "Copy_Document_InvoiceIncome");
  can("update", "Void_Document_Draft_InvoiceIncome");
  can("update", "Draft_Document_InvoiceIncome");
  can("update", "Send_Approve_InvoiceIncome");
  can("update", "Tag_InvoiceIncome");
  can("update", "Accepted_Document_InvoiceIncome");
  can("create", "SendEmail_InvoiceIncome");
}
function ReceiptDraft(can: any) {
  can("create", "Copy_Document_ReceiptIncome");
  can("update", "Void_Document_Draft_ReceiptIncome");
  can("update", "Draft_Document_ReceiptIncome");
  can("update", "Send_Approve_ReceiptIncome");
  can("update", "Tag_ReceiptIncome");
  can("update", "Accepted_Document_ReceiptIncome");
  can("create", "SendEmail_ReceiptIncome");
}
function TaxInvoiceDraft(can: any) {
  can("create", "Copy_Document_TaxInvoiceIncome");
  can("update", "Void_Document_Draft_TaxInvoiceIncome");
  can("update", "Draft_Document_TaxInvoiceIncome");
  can("update", "Send_Approve_TaxInvoiceIncome");
  can("update", "Tag_TaxInvoiceIncome");
  can("update", "Accepted_Document_TaxInvoiceIncome");
  can("create", "SendEmail_TaxInvoiceIncome");
}
function CreditNoteDraft(can: any) {
  can("create", "Copy_Document_CreditNoteIncome");
  can("update", "Void_Document_Draft_CreditNoteIncome");
  can("update", "Draft_Document_CreditNoteIncome");
  can("update", "Send_Approve_CreditNoteIncome");
  can("update", "Tag_CreditNoteIncome");
  can("update", "Accepted_Document_CreditNoteIncome");
  can("create", "SendEmail_CreditNoteIncome");
}
function DebitNoteDraft(can: any) {
  can("create", "Copy_Document_DebitNoteIncome");
  can("update", "Void_Document_Draft_DebitNoteIncome");
  can("update", "Draft_Document_DebitNoteIncome");
  can("update", "Send_Approve_DebitNoteIncome");
  can("update", "Tag_DebitNoteIncome");
  can("update", "Accepted_Document_DebitNoteIncome");
  can("create", "SendEmail_DebitNoteIncome");
}
function BillingNoteDraft(can: any) {
  can("create", "Copy_Document_BillingNoteIncome");
  can("update", "Void_Document_Draft_BillingNoteIncome");
  can("update", "Draft_Document_BillingNoteIncome");
  can("update", "Send_Approve_BillingNoteIncome");
  can("update", "Tag_BillingNoteIncome");
  can("update", "Accepted_Document_BillingNoteIncome");
  can("create", "SendEmail_BillingNoteIncome");
}
function QuotationAdvance(can: any) {
  can("update", "Void_Document_QuotationIncome");
  can("update", "Payment_QuotationIncome");
  can("update", "Void_Payment_QuotationIncome");
  can("create", "Edit_Document_QuotationIncome");
}
function InvoiceAdvance(can: any) {
  can("update", "Void_Document_InvoiceIncome");
  can("update", "Payment_InvoiceIncome");
  can("update", "Void_Payment_InvoiceIncome");
  can("create", "Edit_Document_InvoiceIncome");
}

function ReceiptAdvance(can: any) {
  can("update", "Void_Document_ReceiptIncome");
  can("update", "Payment_ReceiptIncome");
  can("update", "Void_Payment_ReceiptIncome");
  can("create", "Edit_Document_ReceiptIncome");
}
function TaxInvoiceAdvance(can: any) {
  can("update", "Void_Document_TaxInvoiceIncome");
  can("update", "Payment_TaxInvoiceIncome");
  can("update", "Void_Payment_TaxInvoiceIncome");
  can("create", "Edit_Document_TaxInvoiceIncome");
}
function CreditNoteAdvance(can: any) {
  can("update", "Void_Document_CreditNoteIncome");
  can("update", "Payment_CreditNoteIncome");
  can("update", "Void_Payment_CreditNoteIncome");
  can("create", "Edit_Document_CreditNoteIncome");
}
function DebitNoteAdvance(can: any) {
  can("update", "Void_Document_DebitNoteIncome");
  can("update", "Payment_DebitNoteIncome");
  can("update", "Void_Payment_DebitNoteIncome");
  can("create", "Edit_Document_DebitNoteIncome");
}
function BillingNoteAdvance(can: any) {
  can("update", "Void_Document_BillingNoteIncome");
  can("update", "Payment_BillingNoteIncome");
  can("update", "Void_Payment_BillingNoteIncome");
  can("create", "Edit_Document_BillingNoteIncome");
}
function OutflowBaseView(can: any) {
  can("access", "Import_Document");
  can("access", "Expense_Menu");
}
function POView(can: any) {
  can("access", "Quotation_Expense_Menu");
  can("access", "PurchaseOrder_Detail");
}
function ExpenseView(can: any) {
  can("access", "Invoice_Expense_Menu");
  can("access", "PurchaseAsset_Expense_Menu");
  can("access", "Expense_Detail");
}
function PurchaseTaxInvoiceView(can: any) {
  can("access", "TaxInvoice_Expense_Menu");
}
function ReceivedCreditNoteView(can: any) {
  can("access", "CreditNote_Expense_Menu");
  can("access", "ReceiptCreditNote_Detail");
}
function CombinePaymentNoteView(can: any) {
  can("access", "BillingNote_Expense_Menu");
  can("access", "CombinedPayment_Detail");
}
function ReceivedDebitNoteView(can: any) {
  can("access", "DebitNote_Expense_Menu");
  can("access", "ReceiptDebitNote_Detail");
}

function ExpenseApprove(can: any) {
  can("update", "Tag_InvoiceExpense");
  can("update", "Approve_Document_InvoiceExpense");
  can("create", "SendEmail_InvoiceExpense");
  can("update", "Void_Document_InvoiceExpense");
}
function PurchaseTaxInvoiceApprove(can: any) {
  can("update", "Tag_TaxInvoiceExpense");
  can("update", "Approve_Document_TaxInvoiceExpense");
  can("create", "SendEmail_TaxInvoiceExpensee");
  can("update", "Void_Document_TaxInvoiceExpense");
}

function ReceivedDebitNoteApprove(can: any) {
  can("update", "Tag_DebitNoteExpense");
  can("update", "Approve_Document_DebitNoteExpense");
  can("create", "SendEmail_DebitNoteExpense");
  can("update", "Void_Document_DebitNoteExpense");
}
function CombinePaymentNoteApprove(can: any) {
  can("update", "Tag_BillingNoteExpense");
  can("update", "Approve_Document_BillingNoteExpense");
  can("create", "SendEmail_BillingNoteExpense");
  can("update", "Void_Document_BillingNoteExpense");
}
function POCreate(can: any) {
  can("create", "Document_Quotation_Expense");
}
function ExpenseCreate(can: any) {
  can("create", "Document_Invoice_Expense");
}
function PurchaseTaxInvoiceCreate(can: any) {
  can("create", "Document_TaxInvoice_Expense");
}
function ReceivedCreditNoteCreate(can: any) {
  can("create", "Document_CreditNote_Expense");
}
function CombinePaymentNoteCreate(can: any) {
  can("create", "Document_BillingNote_Expense");
}
function ReceivedDebitNoteCreate(can: any) {
  can("create", "Document_DebitNote_Expense");
}
function PODraft(can: any) {
  can("create", "Copy_Document_QuotationExpense");
  can("update", "Void_Document_Draft_QuotationExpense");
  can("update", "Draft_Document_QuotationExpense");
  can("update", "Send_Approve_QuotationExpense");
  can("update", "Tag_QuotationExpense");
  can("update", "Accepted_Document_QuotationExpense");
  can("create", "SendEmail_QuotationExpense");
}
function ExpenseDraft(can: any) {
  can("create", "Copy_Document_InvoiceExpense");
  can("update", "Void_Document_Draft_InvoiceExpense");
  can("update", "Draft_Document_InvoiceExpense");
  can("update", "Send_Approve_InvoiceExpense");
  can("update", "Tag_InvoiceExpense");
  can("update", "Accepted_Document_InvoiceExpense");
  can("create", "SendEmail_InvoiceExpense");
}
function PurchaseTaxInvoiceDraft(can: any) {
  can("create", "Copy_Document_TaxInvoiceExpense");
  can("update", "Void_Document_Draft_TaxInvoiceExpense");
  can("update", "Draft_Document_TaxInvoiceExpense");
  can("update", "Send_Approve_TaxInvoiceExpense");
  can("update", "Tag_TaxInvoiceExpense");
  can("update", "Accepted_Document_TaxInvoiceExpense");
  can("create", "SendEmail_TaxInvoiceExpense");
}
function ReceivedCreditNoteDraft(can: any) {
  can("create", "Copy_Document_CreditNoteExpense");
  can("update", "Void_Document_Draft_CreditNoteExpense");
  can("update", "Draft_Document_CreditNoteExpense");
  can("update", "Send_Approve_CreditNoteExpense");
  can("update", "Tag_CreditNoteExpense");
  can("update", "Accepted_Document_CreditNoteExpense");
  can("create", "SendEmail_CreditNoteExpense");
}
function ReceivedDebitNoteDraft(can: any) {
  can("create", "Copy_Document_DebitNoteExpense");
  can("update", "Void_Document_Draft_DebitNoteExpense");
  can("update", "Draft_Document_DebitNoteExpense");
  can("update", "Send_Approve_DebitNoteExpense");
  can("update", "Tag_DebitNoteExpense");
  can("update", "Accepted_Document_DebitNoteExpense");
  can("create", "SendEmail_DebitNoteExpense");
}
function CombinePaymentNoteDraft(can: any) {
  can("create", "Copy_Document_BillingNoteExpense");
  can("update", "Void_Document_Draft_BillingNoteExpense");
  can("update", "Draft_Document_BillingNoteExpense");
  can("update", "Send_Approve_BillingNoteExpense");
  can("update", "Tag_BillingNoteExpense");
  can("update", "Accepted_Document_BillingNoteExpense");
  can("create", "SendEmail_BillingNoteExpense");
}
function POAdvance(can: any) {
  can("update", "Void_Document_QuotationExpense");
  can("update", "Payment_QuotationExpense");
  can("update", "Void_Payment_QuotationExpense");
  can("create", "Edit_Document_QuotationExpense");
}
function ExpenseAdvance(can: any) {
  can("update", "Void_Document_InvoiceExpense");
  can("update", "Payment_InvoiceExpense");
  can("update", "Void_Payment_InvoiceExpense");
  can("create", "Edit_Document_InvoiceExpense");
}
function ReceivedCreditNoteAdvance(can: any) {
  can("update", "Void_Document_CreditNoteExpense");
  can("update", "Payment_CreditNoteExpense");
  can("update", "Void_Payment_CreditNoteExpense");
  can("create", "Edit_Document_CreditNoteExpense");
}
function PurchaseTaxInvoiceAdvance(can: any) {
  can("update", "Void_Document_TaxInvoiceExpense");
  can("update", "Payment_TaxInvoiceExpense");
  can("update", "Void_Payment_TaxInvoiceExpense");
  can("create", "Edit_Document_TaxInvoiceExpense");
}
function ReceivedDebitNoteAdvance(can: any) {
  can("update", "Void_Document_DebitNoteExpense");
  can("update", "Payment_DebitNoteExpense");
  can("update", "Void_Payment_DebitNoteExpense");
  can("create", "Edit_Document_DebitNoteExpense");
}

function CombinePaymentNoteAdvance(can: any) {
  can("update", "Void_Document_BillingNoteExpense");
  can("update", "Payment_BillingNoteExpense");
  can("update", "Void_Payment_BillingNoteExpense");
  can("create", "Edit_Document_BillingNoteExpense");
}
function POApprove(can: any) {
  can("update", "Tag_QuotationExpense");
  can("update", "Approve_Document_QuotationExpense");
  can("create", "SendEmail_QuotationExpense");
  can("update", "Void_Document_QuotationExpense");
}
function ReceivedCreditNoteApprove(can: any) {
  can("update", "Tag_CreditNoteExpense");
  can("update", "Approve_Document_CreditNoteExpense");
  can("create", "SendEmail_CreditNoteExpense");
  can("update", "Void_Document_CreditNoteExpense");
}
//#region  Revenue
function RevenueView(can: any) {
  RevenueBaseView(can);
  QuotationView(can);
  InvoiceView(can);
  ReceiptView(can);
  TaxInvoiceView(can);
  CreditNoteView(can);
  BillingNoteView(can);
  DebitNoteView(can);
}
function RevenueCreate(can: any) {
  QuotationCreate(can);
  InvoiceCreate(can);
  ReceiptCreate(can);
  TaxInvoiceCreate(can);
  CreditNoteCreate(can);
  DebitNoteCreate(can);
  BillingNoteCreate(can);
}
function RevenueApprove(can: any) {
  QuotationApprove(can);
  InvoiceApprove(can);
  ReceiptApprove(can);
  TaxInvoiceApprove(can);
  CreditNoteApprove(can);
  DebitNoteApprove(can);
  BillingNoteApprove(can);
}
function RevenueDraft(can: any) {
  QuotationDraft(can);
  InvoiceDraft(can);
  ReceiptDraft(can);
  TaxInvoiceDraft(can);
  CreditNoteDraft(can);
  DebitNoteDraft(can);
  BillingNoteDraft(can);
}
function RevenueAdvance(can: any) {
  QuotationAdvance(can);
  InvoiceAdvance(can);
  ReceiptAdvance(can);
  TaxInvoiceAdvance(can);
  CreditNoteAdvance(can);
  DebitNoteAdvance(can);
  BillingNoteAdvance(can);
}
//#region quotation

function UserRightTypeQuotationOnly(can: any) {
  RevenueBaseView(can);
  QuotationView(can);
  QuotationCreate(can);
  QuotationDraft(can);
  QuotationApprove(can);
  QuotationAdvance(can);
}
function UserRightTypeQuotationDraftOnly(can: any) {
  RevenueBaseView(can);
  QuotationView(can);
  QuotationCreate(can);
  QuotationDraft(can);
}
function UserRightTypeQuotationApproveOnly(can: any) {
  RevenueBaseView(can);
  QuotationView(can);
  QuotationApprove(can);
}
//#endregion
//#region Invoice

function UserRightTypeInvoiceOnly(can: any) {
  RevenueBaseView(can);
  InvoiceView(can);
  InvoiceCreate(can);
  InvoiceDraft(can);
  InvoiceApprove(can);
  InvoiceAdvance(can);
}
function UserRightTypeInvoiceDraftOnly(can: any) {
  RevenueBaseView(can);
  InvoiceView(can);
  InvoiceCreate(can);
  InvoiceDraft(can);
}
function UserRightTypeInvoiceApproveOnly(can: any) {
  RevenueBaseView(can);
  InvoiceView(can);
  InvoiceApprove(can);
}
//#endregion
//#region Receipt

function UserRightTypeReceiptOnly(can: any) {
  RevenueBaseView(can);
  ReceiptView(can);
  ReceiptCreate(can);
  ReceiptDraft(can);
  ReceiptApprove(can);
  ReceiptAdvance(can);
}
function UserRightTypeReceiptDraftOnly(can: any) {
  RevenueBaseView(can);
  ReceiptView(can);
  ReceiptCreate(can);
  ReceiptDraft(can);
}
function UserRightTypeReceiptApproveOnly(can: any) {
  RevenueBaseView(can);
  ReceiptView(can);
  ReceiptApprove(can);
}
//#endregion
//#region TaxInvoice

function UserRightTypeTaxInvoiceOnly(can: any) {
  RevenueBaseView(can);
  TaxInvoiceView(can);
  TaxInvoiceCreate(can);
  TaxInvoiceDraft(can);
  TaxInvoiceApprove(can);
  TaxInvoiceAdvance(can);
}
function UserRightTypeTaxInvoiceDraftOnly(can: any) {
  RevenueBaseView(can);
  TaxInvoiceView(can);
  TaxInvoiceCreate(can);
  TaxInvoiceDraft(can);
}
function UserRightTypeTaxInvoiceApproveOnly(can: any) {
  RevenueBaseView(can);
  TaxInvoiceView(can);
  TaxInvoiceApprove(can);
}
//#endregion
//#region CreditNote

function UserRightTypeCreditNoteOnly(can: any) {
  RevenueBaseView(can);
  CreditNoteView(can);
  CreditNoteCreate(can);
  CreditNoteDraft(can);
  CreditNoteApprove(can);
  CreditNoteAdvance(can);
}
function UserRightTypeCreditNoteDraftOnly(can: any) {
  RevenueBaseView(can);
  CreditNoteView(can);
  CreditNoteCreate(can);
  CreditNoteDraft(can);
}
function UserRightTypeCreditNoteApproveOnly(can: any) {
  RevenueBaseView(can);
  CreditNoteView(can);
  CreditNoteApprove(can);
}
//#endregion
//#region BillingNote

function UserRightTypeBillingNoteOnly(can: any) {
  RevenueBaseView(can);
  BillingNoteView(can);
  BillingNoteCreate(can);
  BillingNoteDraft(can);
  BillingNoteApprove(can);
  BillingNoteAdvance(can);
}
function UserRightTypeBillingNoteDraftOnly(can: any) {
  RevenueBaseView(can);
  BillingNoteView(can);
  BillingNoteCreate(can);
  BillingNoteDraft(can);
}
function UserRightTypeBillingNoteApproveOnly(can: any) {
  RevenueBaseView(can);
  BillingNoteView(can);
  BillingNoteApprove(can);
}
//#endregion
//#region DebitNote

function UserRightTypeDebitNoteOnly(can: any) {
  RevenueBaseView(can);
  DebitNoteView(can);
  DebitNoteCreate(can);
  DebitNoteDraft(can);
  DebitNoteApprove(can);
  DebitNoteAdvance(can);
}
function UserRightTypeDebitNoteDraftOnly(can: any) {
  RevenueBaseView(can);
  DebitNoteView(can);
  DebitNoteCreate(can);
  DebitNoteDraft(can);
}
function UserRightTypeDebitNoteApproveOnly(can: any) {
  RevenueBaseView(can);
  DebitNoteView(can);
  DebitNoteApprove(can);
}
//#endregion
//#endregion
//#region Outflow
function OutflowView(can: any) {
  OutflowBaseView(can);
  POView(can);
  ExpenseView(can);
  PurchaseTaxInvoiceView(can);
  ReceivedCreditNoteView(can);
  CombinePaymentNoteView(can);
  ReceivedDebitNoteView(can);
}

function OutflowApprove(can: any) {
  POApprove(can);
  ExpenseApprove(can);
  PurchaseTaxInvoiceApprove(can);
  ReceivedCreditNoteApprove(can);
  ReceivedDebitNoteApprove(can);
  CombinePaymentNoteApprove(can);
}
function OutflowCreate(can: any) {
  POCreate(can);
  ExpenseCreate(can);
  PurchaseTaxInvoiceCreate(can);
  ReceivedCreditNoteCreate(can);
  CombinePaymentNoteCreate(can);
  ReceivedDebitNoteCreate(can);
}
function OutflowDraft(can: any) {
  PODraft(can);
  ExpenseDraft(can);
  PurchaseTaxInvoiceDraft(can);
  ReceivedCreditNoteDraft(can);
  ReceivedDebitNoteDraft(can);
  CombinePaymentNoteDraft(can);
}
function OutflowAdvance(can: any) {
  POAdvance(can);
  ExpenseAdvance(can);
  ReceivedCreditNoteAdvance(can);
  PurchaseTaxInvoiceAdvance(can);
  ReceivedDebitNoteAdvance(can);
  CombinePaymentNoteAdvance(can);
}
//#region PO

function UserRightTypePurchaseOrderOnly(can: any) {
  OutflowBaseView(can);
  POView(can);
  POCreate(can);
  PODraft(can);
  POApprove(can);
  POAdvance(can);
}
function UserRightTypePurchaseOrderDraftOnly(can: any) {
  OutflowBaseView(can);
  POView(can);
  POCreate(can);
  PODraft(can);
}
function UserRightTypePurchaseOrderApproveOnly(can: any) {
  OutflowBaseView(can);
  POView(can);
  POCreate(can);
  POApprove(can);
}
//#endregion
//#region Expense

function UserRightTypeExpenseOnly(can: any) {
  OutflowBaseView(can);
  ExpenseView(can);
  ExpenseCreate(can);
  ExpenseDraft(can);
  ExpenseApprove(can);
  ExpenseAdvance(can);
}
function UserRightTypeExpenseDraftOnly(can: any) {
  OutflowBaseView(can);
  ExpenseView(can);
  ExpenseCreate(can);
  ExpenseDraft(can);
}
function UserRightTypeExpenseApproveOnly(can: any) {
  OutflowBaseView(can);
  ExpenseView(can);
  ExpenseApprove(can);
}
//#endregion
//#region PurchaseTaxInvoice

function UserRightTypePurchaseTaxInvoiceOnly(can: any) {
  OutflowBaseView(can);
  PurchaseTaxInvoiceView(can);
  PurchaseTaxInvoiceCreate(can);
  PurchaseTaxInvoiceDraft(can);
  PurchaseTaxInvoiceApprove(can);
  PurchaseTaxInvoiceAdvance(can);
}
function UserRightTypePurchaseTaxInvoiceDraftOnly(can: any) {
  OutflowBaseView(can);
  PurchaseTaxInvoiceView(can);
  PurchaseTaxInvoiceCreate(can);
  PurchaseTaxInvoiceDraft(can);
}
function UserRightTypePurchaseTaxInvoiceApproveOnly(can: any) {
  OutflowBaseView(can);
  PurchaseTaxInvoiceView(can);
  PurchaseTaxInvoiceApprove(can);
}
//#endregion
//#region ReceivedCreditNote

function UserRightTypeReceivedCreditNoteOnly(can: any) {
  OutflowBaseView(can);
  ReceivedCreditNoteView(can);
  ReceivedCreditNoteCreate(can);
  ReceivedCreditNoteDraft(can);
  ReceivedCreditNoteApprove(can);
  ReceivedCreditNoteAdvance(can);
}
function UserRightTypeReceivedCreditNoteDraftOnly(can: any) {
  OutflowBaseView(can);
  ReceivedCreditNoteView(can);
  ReceivedCreditNoteCreate(can);
  ReceivedCreditNoteDraft(can);
}
function UserRightTypeReceivedCreditNoteApproveOnly(can: any) {
  OutflowBaseView(can);
  ReceivedCreditNoteView(can);
  ReceivedCreditNoteApprove(can);
}
//#endregion
//#region CombinePaymentNote

function UserRightTypeCombinePaymentNoteOnly(can: any) {
  OutflowBaseView(can);
  CombinePaymentNoteView(can);
  CombinePaymentNoteCreate(can);
  CombinePaymentNoteDraft(can);
  CombinePaymentNoteApprove(can);
  CombinePaymentNoteAdvance(can);
}
function UserRightTypeCombinePaymentNoteDraftOnly(can: any) {
  OutflowBaseView(can);
  CombinePaymentNoteView(can);
  CombinePaymentNoteCreate(can);
  CombinePaymentNoteDraft(can);
}
function UserRightTypeCombinePaymentNoteApproveOnly(can: any) {
  OutflowBaseView(can);
  CombinePaymentNoteView(can);
  CombinePaymentNoteApprove(can);
}
//#endregion
//#region ReceivedDebitNote

function UserRightTypeReceivedDebitNoteOnly(can: any) {
  OutflowBaseView(can);
  ReceivedDebitNoteView(can);
  ReceivedDebitNoteCreate(can);
  ReceivedDebitNoteDraft(can);
  ReceivedDebitNoteApprove(can);
  ReceivedDebitNoteAdvance(can);
}
function UserRightTypeReceivedDebitNoteDraftOnly(can: any) {
  OutflowBaseView(can);
  ReceivedDebitNoteView(can);
  ReceivedDebitNoteCreate(can);
  ReceivedDebitNoteDraft(can);
}
function UserRightTypeReceivedDebitNoteApproveOnly(can: any) {
  OutflowBaseView(can);
  ReceivedDebitNoteView(can);
  ReceivedDebitNoteApprove(can);
}
//#endregion
//#endregion

function Approve(can: any) {
  can("update", "Tag");
  can("update", "Approve_Document");
  can("create", "SendEmail");
}

function Draft(can: any) {
  can("create", "Copy_Document");
  can("update", "Void_Document_Draft");
  can("update", "Draft_Document");
  can("update", "Send_Approve");
  can("update", "Tag");
  can("update", "Accepted_Document");
  can("create", "SendEmail");
}
function All(can: any) {
  can("update", "Void_Document");
  can("update", "Payment");
  can("update", "Void_Payment");
  can("create", "Edit_Document");
  can("access", "Contact_Menu");
}
function Setting(can: any) {
  can("access", "General_Setting");
  can("access", "Contact_DashBoard");
}
function Export(can: any) {
  can("create", "Export_Document");
  can("access", "Income_Dashboard");
  can("access", "Expense_Dashboard");
}
function AdvanceSetting(can: any) {
  can("access", "Advance_Setting");
  can("update", "Lock_Document");
}
function TransactionAllReportView(can: any) {
  can("access", "TransactionAllReport");
}
function UserRightTypeBasicAndAdmin(can: any) {
  AdvanceSetting(can);
}
function UserRightTypeViewOnly(can: any) {
  RevenueView(can);
  ExpenseView(can);
  TransactionAllReportView(can);
}
function UserRightTypeRevenueDraftOnly(can: any) {
  RevenueCreate(can);
  RevenueView(can);
  Draft(can);
}

function UserRightTypeRevenueExpenseDraftOnly(can: any) {
  RevenueView(can);
  ExpenseView(can);
  TransactionAllReportView(can);
  RevenueCreate(can);
  ExpenseCreate(can);
  Draft(can);
}
function UserRightTypeRevenueApproveOnly(can: any) {
  RevenueView(can);
  Approve(can);
}

function UserRightTypeRevenueExpenseApproveOnly(can: any) {
  RevenueView(can);
  ExpenseView(can);
  TransactionAllReportView(can);
  Approve(can);
}
function UserRightTypeRevenueAll(can: any) {
  RevenueView(can);
  RevenueCreate(can);
  Draft(can);
  Approve(can);
  All(can);
}
function UserRightTypeExpenseAll(can: any) {
  ExpenseView(can);
  ExpenseCreate(can);
  Draft(can);
  Approve(can);
  All(can);
}

function UserRightTypeStandard(can: any) {
  UserRightTypeRevenueAll(can);
  UserRightTypeExpenseAll(can);
  TransactionAllReportView(can);
  Setting(can);
}

function UserRightTypeCanNotAll(cannot: any) {
  cannot("access", "Income_Menu");
  cannot("access", "Expense_Menu");
  cannot("access", "Product_Menu");
  cannot("access", "Contact_Menu");
  cannot("access", "Invoice_Income_Menu");
  cannot("access", "Receipt_Income_Menu");
  cannot("access", "TaxInvoice_Income_Menu");
  cannot("access", "CreditNote_Income_Menu");
  cannot("access", "DebitNote_Income_Menu");
  cannot("access", "BillingNote_Income_Menu");

  cannot("access", "Quotation_Income_Menu");
  cannot("access", "Quotation_Expense_Menu");
  cannot("access", "Invoice_Expense_Menu");
  cannot("access", "TaxInvoice_Expense_Menu");
  cannot("access", "CreditNote_Expense_Menu");
  cannot("access", "DebitNote_Expense_Menu");
  cannot("access", "BillingNote_Expense_Menu");

  cannot("update", "Tag");
  cannot("create", "Document_Income");
  cannot("create", "Document_Expense");
  cannot("create", "Journal");
  cannot("create", "Edit_Document");
  cannot("create", "Copy_Document");
  cannot("create", "SendEmail");
  cannot("update", "Void_Document");
  cannot("update", "Void_Document_Draft");
  cannot("update", "Lock_Document");
  cannot("update", "Draft_Document");
  cannot("update", "Send_Approve");
  cannot("update", "Approve_Document");
  cannot("update", "Accepted_Document");
  cannot("update", "Payment");
  cannot("update", "Void_Payment");
  cannot("create", "Export_Document");
  cannot("access", "General_Setting");
  cannot("access", "Advance_Setting");
  cannot("access", "Import_Document");
  cannot("access", "Contact_DashBoard");
  cannot("access", "Income_Dashboard");
  cannot("access", "Expense_Dashboard");
  cannot("access", "Dashboard");

  cannot("access", "Quotation_Detail");
  cannot("access", "Invoice_Detail");
  cannot("access", "Receipt_Detail");
  cannot("access", "CreditNote_Detail");
  cannot("access", "DebitNote_Detail");
  cannot("access", "BillingNote_Detail");
  cannot("access", "PurchaseOrder_Detail");
  cannot("access", "Expense_Detail");
  cannot("access", "ReceiptCreditNote_Detail");
  cannot("access", "ReceiptDebitNote_Detail");
  cannot("access", "CombinedPayment_Detail");

  cannot("access", "User_Setting_Menu");

  cannot("access", "Finance_Menu");
  cannot("access", "Account_Menu");
  cannot("access", "Journal_Menu");
  cannot("addOption", "Add_New_Account");
  cannot("addOption", "Add_New_Finance");

  cannot("access", "PeakPayroll");
  cannot("access", "PeakTax");
  cannot("access", "PeakAsset");
  cannot("access", "PeakBoard");

  cannot("access", "TransactionAllReport");

  cannot("create", "Product");
  cannot("update", "Void_Journal");
  cannot("update", "Void_Journal_Draft");
  cannot("update", "Payment_Journal");
  cannot("create", "Edit_Journal");
  cannot("create", "Copy_Journal");
  cannot("update", "Draft_Journal");
  cannot("update", "Send_Approve_Journal");
  cannot("update", "Tag_Journal");
  cannot("create", "SendEmail_Journal");
  cannot("update", "Approve_Journal");
  cannot("create", "SendReview_Journal");
  cannot("update", "ChangeToWaitReview");
  cannot("create", "Edit_DraftJournal");
  cannot("access", "Journal_Detail");
  cannot("access", "View_Create");
  cannot("access", "View_Edit");
  cannot("access", "View_Detail");
}
function ManageUser(isManageUser: boolean, can: any) {
  if (isManageUser) {
    can("access", "User_Setting_Menu");
  }
}
function UserRightTypeRevenueAllExceptQO(can: any) {
  RevenueBaseView(can);
  QuotationView(can);
  UserRightTypeInvoiceOnly(can);
  UserRightTypeReceiptOnly(can);
  UserRightTypeTaxInvoiceOnly(can);
  UserRightTypeCreditNoteOnly(can);
  UserRightTypeBillingNoteOnly(can);
  UserRightTypeDebitNoteOnly(can);
}
function UserRightTypeOutflowAllExceptPO(can: any) {
  OutflowBaseView(can);
  POView(can);
  UserRightTypeExpenseOnly(can);
  UserRightTypePurchaseTaxInvoiceOnly(can);
  UserRightTypeReceivedCreditNoteOnly(can);
  UserRightTypeCombinePaymentNoteOnly(can);
  UserRightTypeReceivedDebitNoteOnly(can);
}
function UserRightTypeRevenueOutflowApproveOnlyExceptQOandPO(can: any) {
  RevenueBaseView(can);
  OutflowBaseView(can);
  QuotationView(can);
  UserRightTypeInvoiceApproveOnly(can);
  UserRightTypeReceiptApproveOnly(can);
  UserRightTypeTaxInvoiceApproveOnly(can);
  UserRightTypeCreditNoteApproveOnly(can);
  UserRightTypeBillingNoteApproveOnly(can);
  UserRightTypeDebitNoteApproveOnly(can);
  POView(can);
  UserRightTypeExpenseApproveOnly(can);
  UserRightTypePurchaseTaxInvoiceApproveOnly(can);
  UserRightTypeReceivedCreditNoteApproveOnly(can);
  UserRightTypeCombinePaymentNoteApproveOnly(can);
  UserRightTypeReceivedDebitNoteApproveOnly(can);
}

function FinanceAccessOnly(can: any) {
  can("access", "Finance_Menu");
  can("addOption", "Add_New_Account");
}
function GLAndStatementOnly(can: any) {
  can("access", "Dashboard");
  can("access", "Account_Menu");
  can("addOption", "Add_New_Account");
  can("access", "PeakTax");
}
function DailyJournalsDraftOnly(can: any) {
  can("access", "Journal_Menu");
  can("create", "Copy_Journal");
  can("create", "Journal");
  can("update", "Void_Journal_Draft");
  can("update", "Draft_Journal");
  can("update", "Send_Approve_Journal");
  can("update", "Tag_Journal");
  can("create", "SendEmail_Journal");
  can("access", "Journal_Detail");
  can("create", "Edit_DraftJournal");
}
function DailyJournalsApproveOnly(can: any) {
  can("access", "Journal_Menu");
  can("update", "Tag_Journal");
  can("update", "Approve_Journal");
  can("create", "SendEmail_Journal");
  can("create", "SendReview_Journal");
  can("update", "ChangeToWaitReview");
  can("access", "Journal_Detail");
}
function DailyJournals(can: any) {
  can("update", "Void_Journal");
  can("update", "Payment_Journal");
  can("create", "Edit_Journal");
  DailyJournalsDraftOnly(can);
  DailyJournalsApproveOnly(can);
}

function DailyJournalsAllAndFinance(can: any) {
  DailyJournals(can);
  FinanceAccessOnly(can);
}
function DailyJournalsDraftOnlyAndFinance(can: any) {
  FinanceAccessOnly(can);
  DailyJournalsDraftOnly(can);
}
function DailyJournalsApproveOnlyAndFinance(can: any) {
  FinanceAccessOnly(can);
  DailyJournalsApproveOnly(can);
}
function DailyJournalsAllAndGL(can: any) {
  DailyJournals(can);
  GLAndStatementOnly(can);
}
function DailyJournalsDraftOnlyAndGL(can: any) {
  DailyJournalsDraftOnly(can);
  GLAndStatementOnly(can);
}
function DailyJournalsApproveOnlyAndGL(can: any) {
  DailyJournalsApproveOnly(can);
  GLAndStatementOnly(can);
}
function FinanceAccountAndDailyJournalsDraftOnly(can: any) {
  GLAndStatementOnly(can);
  FinanceAccessOnly(can);
  DailyJournalsDraftOnly(can);
}
function FinanceAccountAndDailyJournalsApproveOnly(can: any) {
  GLAndStatementOnly(can);
  FinanceAccessOnly(can);
  DailyJournalsApproveOnly(can);
}
function FinanceAndGL(can: any) {
  FinanceAccessOnly(can);
  GLAndStatementOnly(can);
}
function FinanceAndAccount(can: any) {
  FinanceAccessOnly(can);
  GLAndStatementOnly(can);
  DailyJournals(can);
}
function ManageProduct(isManageProduct: boolean, can: any) {
  if (isManageProduct) {
    can("access", "Product_Menu");
    can("create", "Product");
  }
}
function ManageContact(isManageContact: boolean, can: any) {
  if (isManageContact) {
    can("access", "Contact_Menu");
  }
}
function SeeSelfDocuments(isSeeSelfDocuments: boolean, can: any) {
  if (isSeeSelfDocuments) {
    can("access", "Only_Self_Documents");
  }
}
function UsePayroll(isUsePayroll: boolean, can: any) {
  if (isUsePayroll) {
    can("access", "PeakPayroll");
  }
}
function UsePeakBoard(isUsePeakBoard: boolean, can: any) {
  if (isUsePeakBoard) {
    can("access", "PeakBoard");
  }
}
function ManageAsset(isManageAsset: boolean, can: any) {
  if (isManageAsset) {
    can("access", "PeakAsset");
  }
}
function ManageTax(isManageTax: boolean, can: any) {
  if (isManageTax) {
    can("access", "PeakTax");
  }
}
export function DefineAbilityFor(user: any) {
  const { can, cannot, rules } = new AbilityBuilder();
  UserRightTypeCanNotAll(cannot);
  const userRight = user.role.role;
  switch (userRight) {
    //ผู้ดูแลระบบ
    case UserRight.BasicAndAdmin:
      UserRightTypeBasicAndAdmin(can);
      break;
    //ดูได้อย่างเดียว
    case UserRight.ViewOnly:
      UserRightTypeViewOnly(can);
      break;
    //สิทธิบางส่วน
    case UserRight.RevenueDraftOnly:
      UserRightTypeRevenueDraftOnly(can);
      break;
    //สิทธิบางส่วน
    case UserRight.ExpenseDraftOnly:
      UserRightTypeExpenseDraftOnly(can);
      break;
    //สิทธิบางส่วน
    case UserRight.RevenueExpenseDraftOnly:
      UserRightTypeRevenueExpenseDraftOnly(can);
      break;
    //สิทธิบางส่วน
    case UserRight.RevenueApproveOnly:
      UserRightTypeRevenueApproveOnly(can);
      break;
    //สิทธิบางส่วน
    case UserRight.ExpenseApproveOnly:
      UserRightTypeExpenseApproveOnly(can);
      break;
    //สิทธิบางส่วน
    case UserRight.RevenueExpenseApproveOnly:
      UserRightTypeRevenueExpenseApproveOnly(can);
      break;
    //สิทธิบางส่วน
    case UserRight.RevenueAll:
      UserRightTypeRevenueAll(can);
      break;
    //สิทธิบางส่วน
    case UserRight.ExpenseAll:
      UserRightTypeExpenseAll(can);
      break;
    //สิทธิบางส่วน
    case UserRight.QuotationOnly:
      UserRightTypeQuotationOnly(can);
      break;
    //สิทธิบางส่วน
    case UserRight.PurchaseOrderOnly:
      UserRightTypePurchaseOrderOnly(can);
      break;
    //สิทธิมาตรฐาน
    case UserRight.Standard:
      UserRightTypeStandard(can);
      break;
    //สิทธิบางส่วน
    case UserRight.QuotationDraftOnly:
      UserRightTypeQuotationDraftOnly(can);
      break;
    //สิทธิบางส่วน
    case UserRight.QuotationApproveOnly:
      UserRightTypeQuotationApproveOnly(can);
      break;
    //สิทธิบางส่วน
    case UserRight.PurchaseOrderDraftOnly:
      UserRightTypePurchaseOrderDraftOnly(can);
      break;
    //สิทธิบางส่วน
    case UserRight.PurchaseOrderApproveOnly:
      UserRightTypePurchaseOrderApproveOnly(can);
      break;
    case UserRight.RevenueExceptQOAll:
      UserRightTypeRevenueAllExceptQO(can);
      break;
    case UserRight.ExpenseExceptPOAll:
      UserRightTypeOutflowAllExceptPO(can);
      break;
    case UserRight.RevenueExpenseExceptQOandPOApproveOnly:
      UserRightTypeRevenueOutflowApproveOnlyExceptQOandPO(can);
      break;
  }
  const manageFinanceAndJournals = user.role.manageFinanceAndJournals;
  switch (manageFinanceAndJournals) {
    //ไม่มีสิทธิ
    case FinanceAndAccountRights.None:
      break;
    //มีสิทธิทุกอย่าง
    case FinanceAndAccountRights.All:
      FinanceAndAccount(can);
      break;
    //สิทธิการเงิน
    case FinanceAndAccountRights.FinanceAccessOnly:
      FinanceAccessOnly(can);
      break;
    //สิทธิบัญชี
    case FinanceAndAccountRights.GLAndStatementOnly:
      GLAndStatementOnly(can);
      break;
    //สิทธิบัญชีรายวันทั้งหมด
    case FinanceAndAccountRights.DailyJournalsAll:
      DailyJournals(can);
      break;
    //สิทธิบัญชีรายวันร่าง
    case FinanceAndAccountRights.DailyJournalsDraftOnly:
      DailyJournalsDraftOnly(can);
      break;
    //สิทธิบัญชีรายวันอนุมัติ
    case FinanceAndAccountRights.DailyJournalsApproveOnly:
      DailyJournalsApproveOnly(can);
      break;
    //สิทธิบัญชีรายวันทั้งหมดและการเงิน
    case FinanceAndAccountRights.DailyJournalsAllAndFinance:
      DailyJournalsAllAndFinance(can);
      break;
    //สิทธิบัญชีรายวันร่างและการเงิน
    case FinanceAndAccountRights.DailyJournalsDraftOnlyAndFinance:
      DailyJournalsDraftOnlyAndFinance(can);
      break;
    //สิทธิบัญชีรายวันอนุมัติและการเงิน
    case FinanceAndAccountRights.DailyJournalsApproveOnlyAndFinance:
      DailyJournalsApproveOnlyAndFinance(can);
      break;
    //สิทธิบัญชีรายวันทั้งหมดและบัญชี
    case FinanceAndAccountRights.DailyJournalsAllAndGL:
      DailyJournalsAllAndGL(can);
      break;
    //สิทธิบัญชีรายวันร่างและบัญชี
    case FinanceAndAccountRights.DailyJournalsDraftOnlyAndGL:
      DailyJournalsDraftOnlyAndGL(can);
      break;
    //สิทธิบัญชีรายวันอนุมัติและบัญชี
    case FinanceAndAccountRights.DailyJournalsApproveOnlyAndGL:
      DailyJournalsApproveOnlyAndGL(can);
      break;
    //สิทธิบัญชีรายวันร่างการเงินและบัญชี
    case FinanceAndAccountRights.FinanceAccountAndDailyJournalsDraftOnly:
      FinanceAccountAndDailyJournalsDraftOnly(can);
      break;
    //สิทธิบัญชีรายวันอนุมัติการเงินและบัญชี
    case FinanceAndAccountRights.FinanceAccountAndDailyJournalsApproveOnly:
      FinanceAccountAndDailyJournalsApproveOnly(can);
      break;
    //สิทธิการเงินและสิทธิบัญชี
    case FinanceAndAccountRights.FinanceAndGL:
      FinanceAndGL(can);
      break;
  }
  ManageUser(user.role.manageUser, can);
  ManageProduct(user.role.manageProduct, can);
  UsePayroll(user.role.isUsePayroll, can);
  UsePeakBoard(user.role.isUsePeakBoard, can);
  SeeSelfDocuments(user.role.isSeeSelfDocuments, can);
  ManageAsset(user.role.manageAsset, can);
  return rules;
}
